export const INITIAL_STATE = {
  userName: '',
  firstName: '',
  middleName: '',
  lastName: '',
  email: '',
  password: '',
};
